import React, { useEffect, useRef, useState } from "react";
import Styles from "./Dashboard.module.css";
import Navigation from "../../Layout/Navigation/Navigation";
import axios from "axios";
import Table from "../../Layout/Table/Table";
import CustomPagination from "../../Layout/Pagination/ui/Pagination";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input/Input";
import { CircularProgress } from "@mui/material";
import arrowUp from "../../images/arrowUp.svg";
import arrowDown from "../../images/arrowDown.svg";
import { publicIpv4 } from "public-ip";
import Modal from "../../components/Modal/Modal";
import Button from "../../components/Button/Button";
import dollarIll from "../../images/dollar-illustration.svg";
import bellIll from "../../images/bell-illustration.svg";
import smileIll from "../../images/smile-illustration.svg";
import starIll from "../../images/star-illustration.svg";
import searchIll from "../../images/search-illustration.svg";
import heartIll from "../../images/heart-illustration.svg";
import Footer from "../../Layout/Footer/Footer";

const Dashboard = () => {
  const [managersList, setManagersList] = useState({ results: [] });
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const [sortType, setSortType] = useState("ASC");
  const [sortField, setSortField] = useState("filed_company_conformed_name");
  const [state, setState] = useState("");
  const [limitModal, setLimitModal] = useState(false);
  const [popUpInitial, setPopUpInitial] = useState(false);
  const [filters, setFilters] = useState({
    state: "",
  });

  const [filtersModal, setFiltersModal] = useState({
    state: null,
  });

  useEffect(() => {
    const isIpChecked = sessionStorage.getItem("ipcheck");
    const isPopUpInitial = sessionStorage.getItem("popup-modal");
    if (!isIpChecked) {
      const checkIp = async () => {
        try {
          const body = {
            ip: await publicIpv4(),
          };

          const check = await axios.post("/api/auth/ipchecker", body);
          if (check.status === 200) {
            sessionStorage.setItem("ipcheck", "true");
            if (!isPopUpInitial) {
              sessionStorage.setItem("popup-modal", "true");
              setTimeout(() => setPopUpInitial(true), 5000);
            }
          }
        } catch (error) {
          console.log(error?.response?.data);
          if (
            error?.response?.data?.message === "Limit reached" &&
            error?.response?.data?.count === 3
          ) {
            setLimitModal(true);

            setPopUpInitial(false);
          }
        }
      };
      checkIp();
    } else {
      console.log("ip already checked");
      if (!isPopUpInitial) {
        sessionStorage.setItem("popup-modal", "true");
        setTimeout(() => setPopUpInitial(true), 5000);
      }
    }
  }, []);

  useEffect(() => {
    const fetchManagers = async () => {
      if (query === "") {
        setLoading(true);
      }
      try {
        const body = {
          name: query,
          sortType: sortType,
          sortField: sortField,
          size: rowsPerPage,
          offset: rowsPerPage * page,
          state: filters.state,
        };
        const managers = await axios.post("/api/company/", body);
        setManagersList(managers.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchManagers();
  }, [rowsPerPage, page, query, sortField, sortType, filters.state]);

  useEffect(() => {
    const fetchFilters = async () => {
      setLoading(true);
      try {
        const states = await axios.get("/api/company/state");
        setState(states.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchFilters();
  }, []);

  const columns = [
    {
      accessorKey: "filed_company_conformed_name",
      header: () => (
        <div
          onClick={() => {
            setSortType((prev) => (prev === "ASC" ? "DESC" : "ASC"));
            setSortField("filed_company_conformed_name");
          }}
          className={Styles.Header}
        >
          Filed Company Name
          {sortField === "filed_company_conformed_name" ? (
            sortType === "ASC" ? (
              <img src={arrowUp} alt="up" width={15} height={15} />
            ) : (
              <img src={arrowDown} alt="down" width={15} height={15} />
            )
          ) : null}
        </div>
      ),
      cell: ({ row }) => (
        <div
          className={Styles.NameCell}
          onClick={() => {
            navigate(`/overview/${row.original.filed_central_index_key}`);
          }}
        >
          {row.original.filed_company_conformed_name}
        </div>
      ),
    },

    {
      accessorKey: "filed_state",
      header: () => (
        <div
          onClick={() => {
            setSortType((prev) => (prev === "ASC" ? "DESC" : "ASC"));
            setSortField("filed_state");
          }}
          className={Styles.Header}
          style={{
            justifyContent: "center",
          }}
        >
          State
          {sortField === "filed_state" ? (
            sortType === "ASC" ? (
              <img src={arrowUp} alt="up" width={15} height={15} />
            ) : (
              <img src={arrowDown} alt="down" width={15} height={15} />
            )
          ) : null}
        </div>
      ),
      cell: ({ row }) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {row.original.filed_state}
        </div>
      ),
    },
    {
      accessorKey: "filed_city",
      header: () => (
        <div
          onClick={() => {
            setSortType((prev) => (prev === "ASC" ? "DESC" : "ASC"));
            setSortField("filed_city");
          }}
          className={Styles.Header}
          style={{
            justifyContent: "end",
          }}
        >
          City
          {sortField === "filed_city" ? (
            sortType === "ASC" ? (
              <img src={arrowUp} alt="up" width={15} height={15} />
            ) : (
              <img src={arrowDown} alt="down" width={15} height={15} />
            )
          ) : null}
        </div>
      ),
      cell: ({ row }) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          {row.original.filed_city}
        </div>
      ),
    },
  ];

  const handleClearFilters = () => {
    setFilters({
      state: "",
    });
  };

  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setFiltersModal({
        state: false,
      });
    }
  };

  useEffect(() => {
    if (filtersModal.state) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filtersModal]);

  return loading ? (
    <div className={Styles.Loader}>
      <CircularProgress />
    </div>
  ) : (
    <div className={Styles.App}>
      <Navigation />
      <div className={Styles.Hero}>
        <img
          src={dollarIll}
          alt="dollar-illustration"
          width={80}
          className={Styles.DollarIllustration}
        />
        <img
          src={bellIll}
          alt="bell-illustration"
          width={100}
          className={Styles.BellIllustration}
        />
        <img
          src={smileIll}
          alt="smile-illustration"
          width={110}
          className={Styles.SmileIllustration}
        />
        <img
          src={starIll}
          alt="star-illustration"
          width={80}
          className={Styles.StarIllustration}
        />
        <img
          src={searchIll}
          alt="search-illustration"
          width={40}
          className={Styles.SearchIllustration}
        />
        <img
          src={heartIll}
          alt="heart-illustration"
          width={30}
          className={Styles.HeartIllustration}
        />
        <div className={Styles.HeroText}>
          <h1>
            Real-Time{" "}
            <span className={Styles.HighlightHeroText}>SEC 13G Insights</span>{" "}
            at Your Fingertips
          </h1>
          <p>
            Get real-time access to SEC 13G filings and track key shareholder
            moves instantly. Stay informed and make smarter decisions, faster.
          </p>
        </div>
        <div style={{ width: "100%", maxWidth: "400px" }}>
          <Input
            value={query || ""}
            placeholder={"Search filed company name"}
            icon
            onChange={(e) => {
              setQuery(e.target.value);
            }}
          />
        </div>
        <div className={Styles.TrendingSearches}>
          <h5>Trending Searches</h5>
          <div className={Styles.TrendingSearchesContent}>
            {["Berkshire Hathaway", "BlackRock", "JPMorgan"].map((item, i) => {
              return (
                <p
                  onClick={() => setQuery(item)}
                  key={i}
                  className={Styles.TrendingSearchesButton}
                >
                  {item}
                </p>
              );
            })}
          </div>
        </div>
      </div>
      <div className={Styles.TableWrapper}>
        <div className={Styles.FiltersWrapper}>
          <div className={Styles.FiltersModalWrapper}>
            <div
              onClick={() => {
                setFiltersModal((prev) => {
                  return {
                    state: !prev.state,
                  };
                });
              }}
              className={Styles.FiltersModalInput}
            >
              {filters.state === null || filters.state === ""
                ? "State"
                : `${filters.state}`}
            </div>
            {filtersModal.state ? (
              <div className={Styles.FiltersModal} ref={modalRef}>
                <ul>
                  {state?.map((item, i) => {
                    return (
                      <li
                        data-value={item[1]}
                        key={i}
                        onClick={(e) => {
                          setFilters((prev) => {
                            return {
                              ...prev,
                              state: e.target.getAttribute("data-value"),
                            };
                          });
                          setFiltersModal((prev) => {
                            return {
                              ...prev,
                              state: !prev.state,
                            };
                          });
                        }}
                      >
                        {item[0]}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : null}
          </div>

          <div
            onClick={() => {
              handleClearFilters();
              setFiltersModal({
                state: false,
              });
            }}
            className={Styles.FiltersModalInput}
          >
            Clear
          </div>
        </div>
        <div className={Styles.TableContainer}>
          <Table
            data={managersList.results ? managersList.results : []}
            columns={columns}
          />
        </div>
        <CustomPagination
          count={managersList?.total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(newPage) => setPage(newPage)}
          onRowsPerPageChange={(newRowsPerPage) => {
            setRowsPerPage(newRowsPerPage);
            setPage(0);
          }}
        />
      </div>
      <div className={Styles.ContactUsCte}>
        <div className={Styles.ContactUsContent}>
          <div className={Styles.TextContactUsCte}>
            <h5>Need more data?</h5>
            <p>Contact us via form, request as much you need.</p>
          </div>
          <Button onClick={() => navigate("/contact-us")}>Contact us</Button>
        </div>
      </div>
      <Footer />
      <Modal open={limitModal} title={"Ops..."}>
        <div className={Styles.ModalBody}>
          <p>
            It looks like you really like our website, you hit the daily limit.
            But if you want to continue please let us know which data you need.
          </p>
          <Button
            style={{ width: "100%" }}
            onClick={() => {
              setLimitModal(false);

              navigate("/contact-us");
            }}
          >
            Request Data
          </Button>
        </div>
      </Modal>
      <Modal
        open={popUpInitial}
        title={"Welcome"}
        closeBtn={true}
        setOpen={() => setPopUpInitial(false)}
      >
        <div className={Styles.ModalBody}>
          <p>
            We're happy to connect with you. If you want to request more
            specific data please click below.
          </p>
          <Button
            style={{ width: "100%" }}
            onClick={() => {
              setPopUpInitial(false);

              navigate("/contact-us");
            }}
          >
            Request Data
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default Dashboard;
